import { coreSonarObjectsInitiativesGetAsyncSlice } from './get';

export const { requestGetCoreSonarObjectsInitiatives, resetGetCoreSonarObjectsInitiatives } =
	coreSonarObjectsInitiativesGetAsyncSlice.asyncActionCreators;
